module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Copyright © 1988 by White Mountain Company")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("“Provide, Provide” copyright © 1936 by Robert Frost. Copyright © 1964 by Lesley Frost Ballantine. Copyright © 1969 by Holt, Rinehart and Winston. Reprinted from "), _c('em', [_vm._v("The Poetry of Robert Frost")]), _vm._v(" edited by Edward Connery Lathem, by permission of Henry Holt and Company, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("“To the Film Industry in Crisis” copyright © 1957 by Frank O’Hara."), _c('br'), _vm._v("Reprinted by permission of Grove/Atlantic, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Published simultaneously in Canada"), _c('br'), _vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Tolkin, Michael."), _c('br'), _vm._v("The player: a novel/by Michael Tolkin"), _c('br'), _vm._v("I. Title."), _c('br'), _vm._v("PS3570.042781P55      1988      813′.54—dc19         87-33478"), _c('br'), _vm._v("eBook ISBN-13: 978-1-5558-4747-0")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Design by Laura Hough")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("an imprint of Grove/Atlantic, Inc."), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Distributed by Publishers Group West"), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.groveatlantic.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06aa9c8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05_copy.vue
// module id = 75
// module chunks = 0